import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { HttpRequest } from "@smithy/protocol-http";
import { getChecksumAlgorithmListForResponse } from "./getChecksumAlgorithmListForResponse";
import { getChecksumLocationName } from "./getChecksumLocationName";
import { isChecksumWithPartNumber } from "./isChecksumWithPartNumber";
import { isStreaming } from "./isStreaming";
import { createReadStreamOnBuffer } from "./streams/create-read-stream-on-buffer";
import { validateChecksumFromResponse } from "./validateChecksumFromResponse";
export var flexibleChecksumsResponseMiddlewareOptions = {
  name: "flexibleChecksumsResponseMiddleware",
  toMiddleware: "deserializerMiddleware",
  relation: "after",
  tags: ["BODY_CHECKSUM"],
  override: true
};
export var flexibleChecksumsResponseMiddleware = function flexibleChecksumsResponseMiddleware(config, middlewareConfig) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var input, result, response, collectedStream, requestValidationModeMember, responseAlgorithms, clientName, commandName, isS3WholeObjectMultipartGetResponseChecksum, isStreamingBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (HttpRequest.isInstance(args.request)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", next(args));
              case 2:
                input = args.input;
                _context.next = 5;
                return next(args);
              case 5:
                result = _context.sent;
                response = result.response;
                collectedStream = undefined;
                requestValidationModeMember = middlewareConfig.requestValidationModeMember, responseAlgorithms = middlewareConfig.responseAlgorithms;
                if (!(requestValidationModeMember && input[requestValidationModeMember] === "ENABLED")) {
                  _context.next = 23;
                  break;
                }
                clientName = context.clientName, commandName = context.commandName;
                isS3WholeObjectMultipartGetResponseChecksum = clientName === "S3Client" && commandName === "GetObjectCommand" && getChecksumAlgorithmListForResponse(responseAlgorithms).every(function (algorithm) {
                  var responseHeader = getChecksumLocationName(algorithm);
                  var checksumFromResponse = response.headers[responseHeader];
                  return !checksumFromResponse || isChecksumWithPartNumber(checksumFromResponse);
                });
                if (!isS3WholeObjectMultipartGetResponseChecksum) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return", result);
              case 14:
                isStreamingBody = isStreaming(response.body);
                if (!isStreamingBody) {
                  _context.next = 20;
                  break;
                }
                _context.next = 18;
                return config.streamCollector(response.body);
              case 18:
                collectedStream = _context.sent;
                response.body = createReadStreamOnBuffer(collectedStream);
              case 20:
                _context.next = 22;
                return validateChecksumFromResponse(result.response, {
                  config: config,
                  responseAlgorithms: responseAlgorithms
                });
              case 22:
                if (isStreamingBody && collectedStream) {
                  response.body = createReadStreamOnBuffer(collectedStream);
                }
              case 23:
                return _context.abrupt("return", result);
              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};